import { Component, OnInit } from '@angular/core';
import { CalibrationDelivery_Interface, Empty_CalibrationDelivery_Interface } from 'src/app/Interface/CalibrationDelivery_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationDeliveryService } from 'src/app/Service/CalibrationDelivery/CalibrationDelivery.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CalibrationDeliveryList',
  templateUrl: './CalibrationDeliveryList.component.html',
  styleUrls: ['./CalibrationDeliveryList.component.scss']
})
export class CalibrationDeliveryListComponent implements OnInit {
  page:number=0;
  Procssing:boolean=false;
  Selected_CalibrationDelivery_Id:number=-1

  StartSearchDate:string=""
  EndSearchDate:string=""
  SubmitPeriodDate:string="1"

  constructor(
    private CalibrationDelivery_Service:CalibrationDeliveryService,
    private Nav_Service:NavService,
    private Alerify:AlertifyService,
  ) { }


  DataList_CalibrationDelivery:Array<CalibrationDelivery_Interface>=[]
  DataList_CalibrationDelivery_Excel:Array<any>=[]
  Selected_DataList_CalibrationDelivery:CalibrationDelivery_Interface=Empty_CalibrationDelivery_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1146).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Filter_customer:String=''
  Filter_code:String=''

  ReadData_CalibrationDelivery(StartSearchDate,EndSearchDate){
    this.Procssing=true

    this.StartSearchDate=StartSearchDate
    this.EndSearchDate=EndSearchDate


    this.CalibrationDelivery_Service.GetRecord(
      StartSearchDate,
      EndSearchDate,
      this.Filter_customer,
      this.SubmitPeriodDate).subscribe(
      data=>{

        this.DataList_CalibrationDelivery=data

        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  modalRef_upload: any;
  ProcssingUpload:boolean=false





  OnSet_Selected_CalibrationDelivery_Id(id:number){
    this.Selected_CalibrationDelivery_Id=id
  }

  OnSet_Selected_CalibrationDelivery_Item(item:CalibrationDelivery_Interface){
    this.Selected_DataList_CalibrationDelivery=item
    this.Selected_CalibrationDelivery_Id=1
  }


  OnSet_Back_CalibrationDelivery_Id(){
    this.Selected_CalibrationDelivery_Id=-1
  }

}


